import {Operation} from "./Operation.js";


export class Subtract extends Operation {

    static symbol = "-";

    /**
     * Perform subtraction on the two values.
     * @param {Row} row - A row object containing the values to subtract.
     * @returns {number} The result of subtracting rightValue from leftValue.
     */
    perform(row) {
        const [leftValue, rightValue] = this.getOperands(row);
        return (leftValue || 0) - (rightValue || 0);
    }
}